// extracted by mini-css-extract-plugin
module.exports = {"imageHolder":"e_uj","imageUI":"e_vj","badgeContainer":"e_wj","badgeImage":"e_xj","container":"e_yj"};